/* @skip-file-for-translation */
import { MessageDescriptor } from '@lingui/core';
import {
  BuildingSizeUnit,
  BuildingUtilityType,
} from '@watershed/constants/buildings';

import { msg } from '@lingui/core/macro';
import { BuildingCleanPowerStatus } from './BuildingUtils';

export const UNIT_NAMES: {
  [key in 'short' | 'long']: {
    [unit in BuildingSizeUnit]: MessageDescriptor;
  };
} = {
  long: {
    [BuildingSizeUnit.SquareFeet]: msg({
      message: 'Square feet',
      context: 'Unit for building size',
    }),
    [BuildingSizeUnit.SquareMeters]: msg({
      message: 'Square meters',
      context: 'Unit for building size',
    }),
  },
  short: {
    [BuildingSizeUnit.SquareFeet]: msg({
      message: 'ft²',
      context: 'Abbreviated unit for building size',
    }),
    [BuildingSizeUnit.SquareMeters]: msg({
      message: 'm²',
      context: 'Abbreviated unit for building size',
    }),
  },
} as const;

export const CLEAN_POWER_NAMES: {
  [cleanPowerStatus in BuildingCleanPowerStatus]: MessageDescriptor;
} = {
  ['NoCleanPower']: msg({
    message: 'No',
    context: 'Option for when a building has no clean power',
  }),
  ['PartialCleanPower']: msg({
    message: 'Yes, covering partial power consumption',
    context: 'Option for when a building has partial clean power',
  }),
  ['FullCleanPower']: msg({
    message: 'Yes, covering all power consumption',
    context: 'Option for when a building has full clean power',
  }),
  ['Unknown']: msg({
    message: 'I don’t know',
    context:
      'Option for when the user is unsure whether a building has full, partial, or no clean power',
  }),
} as const;

export const PARTIAL_CLEAN_POWER_PERCENTAGE_DEFAULT = 50;

export const BUILDING_UTILITY_TYPE_NAMES: Record<
  BuildingUtilityType,
  MessageDescriptor
> = {
  [BuildingUtilityType.ElectricityConsumption]: msg({
    message: 'Electricity',
    context: 'Utility type',
  }),
  [BuildingUtilityType.StationaryCombustion]: msg({
    message: 'Heating & fuel',
    context: 'Utility type',
  }),
  [BuildingUtilityType.Waste]: msg({
    message: 'Waste',
    context: 'Utility type',
  }),
  [BuildingUtilityType.Water]: msg({
    message: 'Water',
    context: 'Utility type',
  }),
  [BuildingUtilityType.Refrigerant]: msg({
    message: 'Refrigerants',
    context: 'Utility type',
  }),
} as const;

// Ordered in the order they should be displayed in the UI
export const ALL_BUILDING_UTILITY_TYPES = Object.keys(
  BUILDING_UTILITY_TYPE_NAMES
) as Array<BuildingUtilityType>;

export function isEstimationSupportedForUtilityType(
  utilityType: BuildingUtilityType,
  building: {
    isWithoutRefrigerants: boolean | null;
    isWithoutNaturalGas: boolean | null;
  }
): boolean {
  if (utilityType === BuildingUtilityType.Refrigerant) {
    return !building.isWithoutRefrigerants;
  }
  if (utilityType === BuildingUtilityType.StationaryCombustion) {
    return !building.isWithoutNaturalGas;
  }
  return utilityType === BuildingUtilityType.ElectricityConsumption;
}
